import React,{ Component } from "react";
import './index.less'
import Axios from "../../../../components/request/axios";
class Banner extends Component {
    state={
        news:[],
        idArr:[],
    };
    componentDidMount() {
        let hideMenus=window.localStorage.getItem("hideMenus");
        let _this=this;
        if(hideMenus){
            let  menusArr=JSON.parse(hideMenus);
            let idArr=[];
            for(let i=0;i<menusArr.length;i++){///党的精神是第一层菜单
                if(menusArr[i].name==='党的精神'){//这边是定死的
                    idArr.push(menusArr[i].key);
                    this.setState({
                        idArr,
                    });
                    let params={
                        channel__id:menusArr[i].key
                    };
                    Axios.get('/api/v1/news/',params).then((res)=>{
                        if(res){
                            let news=res.results;
                            _this.setState({
                                news:news,
                            });
                        }
                    });
                    break
                }
            }
        }
    }
    render() {
        let {news,idArr}=this.state;
        let breadcrumb=JSON.stringify([]);
        let content=<div/>;
        if(news.length>0&&news[0].big_image){
            let hash='#/news/newshow?id='+news[0].id+"&key="+idArr[0]+'&breadcrumb='+encodeURI(breadcrumb);
            content=<a href={hash}>
                <img src={news[0].big_image.file} alt='banner' style={{width:'100%',margin:'30px 0 0 0'}} />
            </a>
        }
        return  content
    }
}
export default Banner